<template>
  <div class="page-wrap">
    <div class="session-form-hold">
      <base-card>
        <v-progress-linear :active="loading" :indeterminate="loading" absolute top color="primary"></v-progress-linear>

        <v-row>
          <v-spacer></v-spacer>
          <ca-lang-selector class="me-3" />
        </v-row>

        <v-card-text class="text-center">
          <v-avatar size="60" class="mb-4">
            <img src="@/assets/images/logo.svg" alt="" />
          </v-avatar>

          <h6 class="text--disabled font-weight-medium mb-10">
            {{ $t("auth.recovering_password") }}
          </h6>

          <ca-alert v-show="alert.message" :type="alert.type">
            <span v-html="alert.message"></span>
          </ca-alert>

          <p v-if="loading">{{ $t("common.wait") }}</p>

          <v-form>
            <div class="text-center">
              <v-btn text small color="primary" class="mb-2" :to="{ name: 'login' }">
                {{ $t("auth.sign_in") }}
              </v-btn>
            </div>
          </v-form>
        </v-card-text>
      </base-card>
    </div>
  </div>
</template>

<script>
import CaAlert from "@/views/components/Alert";

export default {
  components: { CaAlert },

  metaInfo() {
    return {
      title: this.$t("titles.password_recovery")
    };
  },

  data() {
    return {
      alert: {
        message: null,
        type: "warning"
      },
      show: false,
      loading: false
    };
  },

  computed: {
    token() {
      return this.$route.params.token;
    },
    email() {
      return this.$route.params.email;
    }
  },

  mounted() {
    this.restorePassword();
  },

  methods: {
    restorePassword() {
      this.loading = true;

      this.axios
        .post("auth/restore-password", {
          email: this.email,
          token: this.token
        })
        .then(response => {
          this.loading = false;

          if (response.data.success) {
            this.alert.message = this.$t("auth.password_changed_success");
            this.alert.type = "success";
          } else {
            this.alert.message = this.$t("auth.invalid_recover_password_link");
            this.alert.type = "warning";
          }
        })
        .catch(error => {
          this.loading = false;

          const response = error.response;

          if (response.status === 422) {
            this.alert.message = this.$t("auth.invalid_recover_password_link");
            this.alert.type = "warning";
          }
        });
    }
  }
};
</script>
